import { render, staticRenderFns } from "./ListTrendsItem.vue?vue&type=template&id=183e1460&scoped=true&"
import script from "./ListTrendsItem.vue?vue&type=script&lang=js&"
export * from "./ListTrendsItem.vue?vue&type=script&lang=js&"
import style0 from "./ListTrendsItem.vue?vue&type=style&index=0&id=183e1460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e1460",
  null
  
)

component.options.__file = "ListTrendsItem.vue"
export default component.exports